// relative paths
export const MY_TRIPS_PATH_RELATIVE = "trips";
export const WALLET_PATH_RELATIVE = "wallet";
export const FLIGHTS_PATH_RELATIVE = "flights";
export const HOTELS_PATH_RELATIVE = "hotels";
export const CARS_PATH_RELATIVE = "cars";
export const USER_ONBOARD_PATH_RELATIVE = "user-onboarding";
export const DISRUPTION_EXERCISE_RELATIVE =
  "disruption/exercise/:reservationId";

export const SEARCH_ORIGIN_PATH_RELATIVE = "search/origin";
export const SEARCH_DESTINATION_PATH_RELATIVE = "search/destination";
export const DISRUPTION_PATH_RELATIVE = "customize/disruption";

export const SEARCH_LOCATION_PATH_RELATIVE = "search/location";
export const SEARCH_CALENDAR_PATH_RELATIVE = "search/calendar";

export const SEARCH_PICKUP_PATH_RELATIVE = "search/pickup";
export const SEARCH_DROP_OFF_PATH_RELATIVE = "search/dropoff";

export const HOME_PATH_RELATIVE = "";

// Absolute paths
export const COMING_SOON_PATH = "/coming-soon";
export const INVALID_SESSION_PATH = "/auth/invalidsession";
export const AUTHORIZE_LOGIN_PATH = "/auth/authorize";
export const MOCK_LOGIN_PATH = "/mock-login";
export const FLIGHTS_PATH = "/flights";
export const FLIGHTS_BOOK_PATH = "/flights/book";
export const HOTELS_PATH = "/hotels";
export const CARS_PATH = "/cars";
export const TRIPS_PATH = "/trips";
export const PAST_TRIPS_PATH = `${TRIPS_PATH}/past`;
export const WALLET_PATH = "/wallet";
export const CUSTOMER_SUPPORT_PATH = "/trips/customerSupport";
export const PRIVACY_POLICY_PATH = "/privacy";
export const TERMS_AND_CONDITIONS_PATH = "/terms";
export const FREQUENT_ASK_QUESTIONS_PATH = "/faqs";
export const HOME_PATH = "/";
export const HOTELS_SEARCH_LOCATION_PATH = "/hotels/search/location";
export const HOTELS_SEARCH_CALENDAR_PATH = "/hotels/search/calendar";
export const CARS_SEARCH_PICKUP_PATH = "/cars/search/pickup";
export const CARS_SEARCH_DROP_OFF_PATH = "/cars/search/dropoff";
export const FLIGHTS_DESTINATION_PATH = "/search/destination";

// export const DISRUPTION_EXERCISE_PATH = "/trips/disruptionExercise";
// export const FLIGHT_ITINERARY_PAGE_PATH = "/trips/flights";
